<template>
  <PageWrapper
    :handleBack="goToCenterExecutePlannerList"
    bodyClass="heigh--100vh overflow-y-hidden"
  >
    <Tabs :tabs="tabs" tabContentClass="overflow-y-hidden">
      <template #tab-0>
        <ListWrapper
          ref="listWrapperReference"
          :url="listUrl"
          :extraParams="{ order_by: 'executive_role_id:asc-id:asc' }"
          :title="$lang.centerExecutePersons"
          :isUseInSidebar="true"
          :hasAddButton="false"
          menuBarClass="padding-x-16"
          searchTxtClass="width-percent-100"
          wrapperClass="background-surface border-radius-8 border--solid border--complementary-50 padding-y-16"
          wrapperListContentClass="height--100vh--338"
          titleClass="padding-x-16"
          @getPermissions="getPermissions"
        >
          <template #out-area>
            <Alert
              class="margin-bottom-16"
              :text="$lang.centerExecutePersonAlert"
              variant="light-warning"
            />
          </template>
          <template slot-scope="{ items, itemsLoading }">
            <LoadingWrapper :loading="itemsLoading">
              <template #loading>
                <ListLoading :count="5" />
              </template>
              <template #default>
                <b-row class="margin-0 padding-x-16">
                  <b-col
                    cols="12"
                    v-for="(item, index) in generateItems(items)"
                    :key="index"
                    class="border--solid border--complementary-50 border-radius-8 margin-bottom-8 padding-0"
                  >
                    <PersonItem :item="item" :hasCreateReportChange="false" />
                  </b-col>
                </b-row>
              </template>
            </LoadingWrapper>
          </template>
        </ListWrapper>
      </template>
      <template #tab-1>
        <CenterExecuteAttachments />
      </template>
    </Tabs>
  </PageWrapper>
</template>

<script>
import {
  PageWrapper,
  Tabs,
  ListWrapper,
  Alert,
  LoadingWrapper,
} from "@/components/re-design";
import ListLoading from "../center-execute/center-execute-edit/persons/ListLoading.vue";
import PersonItem from "../center-execute/center-execute-edit/persons/PersonItem.vue";
import CenterExecuteAttachments from "../center-execute/center-execute-edit/attachments/CenterExecuteAttachments.vue";
import { pathOr } from "ramda";
import { computed, onMounted, provide, ref } from "vue";
import {
  generateApiUrl,
  generateCurrentRoute,
  generateError,
  goToRoute,
  generateLang,
  storeDispatcher,
} from "@/shared/utils";
import { getCenterExecuteV1 } from "@/modules/kanoon/services";

export default {
  components: {
    PageWrapper,
    Tabs,
    ListWrapper,
    Alert,
    LoadingWrapper,
    ListLoading,
    PersonItem,
    CenterExecuteAttachments,
  },
  setup() {
    const tabs = ["افراد", "پیوست ها"];

    const centerExecuteId = generateCurrentRoute(["params", "centerExecuteId"]);
    const listUrl = computed(() => {
      return generateApiUrl(
        ["kanoon", "centerExecutePerson"],
        [centerExecuteId]
      );
    });

    const goToCenterExecutePlannerList = () => {
      goToRoute("center-execute-planner", {}, {}, false);
    };

    // handle permissions
    const permissions = ref([]);
    const getPermissions = (data) => (permissions.value = data);

    // generate list
    const generateItems = (items) => {
      return items.map((item) => {
        const parvandeh = pathOr(null, ["parvandeh"], item);
        const parvandehCode = pathOr(null, ["code"], parvandeh);
        const parvandehNumber = pathOr("", ["parvandeh_number"], parvandeh);
        const personNationalCode = pathOr(
          "",
          ["person", "national_code"],
          parvandeh
        );
        const personName = pathOr("", ["person", "name"], parvandeh);
        const personAvatar = pathOr("", ["person", "image_address"], parvandeh);
        const termCaption = pathOr("", ["term_caption"], parvandeh);

        const secondPerson = pathOr(null, ["second_assessor_parvandeh"], item);
        const secondPersonParvandehNumber = pathOr(
          "",
          ["parvandeh_number"],
          secondPerson
        );
        const secondPersonNationalCode = pathOr(
          "",
          ["person", "national_code"],
          secondPerson
        );
        const secondPersonName = pathOr("", ["person", "name"], secondPerson);
        const secondPersonAvatar = pathOr(
          "",
          ["person", "image_address"],
          secondPerson
        );
        const secondPersonTermCaption = pathOr(
          "",
          ["term_caption"],
          secondPerson
        );

        const executiveRole = pathOr(null, ["executive_role"], item);

        const candidateSearchWithNationalCode = pathOr(
          false,
          ["candidateSearchWithNationalCode"],
          centerExecuteData.value
        );
        const executivePersonSearchWithNationalCode = pathOr(
          false,
          ["executivePersonSearchWithNationalCode"],
          centerExecuteData.value
        );
        const executivePersonTermFilter = pathOr(
          [],
          ["executivePersonTermFilter"],
          centerExecuteData.value
        );

        return {
          id: pathOr(null, ["id"], item),
          isAbsentId: pathOr(0, ["is_absent", "id"], item),
          isAbsentCaption: pathOr("", ["is_absent", "caption"], item),
          isCreateReport: pathOr(false, ["is_create_report"], item),
          isPlanningPerson: pathOr(0, ["is_planing_person"], item),
          centerExecuteState: pathOr(null, ["center_execute_state"], item),
          executiveRoleId: pathOr(null, ["id"], executiveRole),
          executiveRoleCaption: pathOr("", ["caption"], executiveRole),
          candidateSearchWithNationalCode,
          executivePersonSearchWithNationalCode,
          executivePersonTermFilter,
          parvandehCode,
          parvandehNumber,
          personNationalCode,
          personName,
          personAvatar,
          personCode: pathOr(null, ["person", "code"], parvandeh),
          personCenterExecuteCode: pathOr(
            "",
            ["person_center_execute_code"],
            item
          ),
          secondPerson,
          secondPersonCode: pathOr(null, ["person", "code"], secondPerson),
          secondPersonName,
          secondPersonAvatar,
          secondPersonParvandehNumber,
          secondPersonNationalCode,
          oneDropdown: parvandeh
            ? {
                id: parvandehCode,
                caption: `${personNationalCode} - ${personName} - ${termCaption}`,
              }
            : null,
          twoDropdown: secondPerson
            ? {
                id: pathOr("", ["code"], secondPerson),
                caption: `${secondPersonNationalCode} - ${secondPersonName} - ${secondPersonTermCaption}`,
              }
            : null,
          executiveRole: {
            id: pathOr("", ["id"], executiveRole),
            caption: pathOr("", ["caption"], executiveRole),
          },
        };
      });
    };

    // handle reload list
    const listWrapperReference = ref(null);
    const handleReloadList = () => listWrapperReference.value.reload();

    const setMobileHeaderTitle = () => {
      const { title } = centerExecuteData.value;
      const headerTitle = `${generateLang([
        "centerExecuteEdit",
      ])} <span class="margin-right-4">${title}</span>`;
      storeDispatcher("mobileHeaderTitleText", headerTitle);
    };

    const centerExecuteData = ref(null);
    const loading = ref(false);
    const fetchData = async () => {
      try {
        loading.value = true;
        const response = await getCenterExecuteV1(centerExecuteId);
        const { getData } = response;
        centerExecuteData.value = getData;
        setMobileHeaderTitle();
      } catch (error) {
        generateError(error);
      } finally {
        loading.value = false;
      }
    };
    onMounted(() => fetchData());

    // provide data
    provide(
      "PERMISSIONS",
      computed(() => permissions.value)
    );
    provide("handleReloadList", handleReloadList);
    provide(
      "CENTER_EXECUTE_DATA",
      computed(() => centerExecuteData.value)
    );

    // return data to be used in template
    return {
      tabs,
      listUrl,
      getPermissions,
      generateItems,
      listWrapperReference,
      goToCenterExecutePlannerList,
    };
  },
};
</script>
